export const isValidZip = (z) => /^\d{5}$/.test(z);
export const isValidPhone = (p) => {
  const digits = p.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
};

// Pragmatic email check: one @, a non-empty local part, and a dotted domain
// with a 2+ char TLD. Deliberately not RFC-5322-exhaustive — the backend is
// the source of truth; this just rejects obvious garbage at the gate so a
// stray "@" no longer counts as a valid address.
export const isValidEmail = (e) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(e || "").trim());

// Spec-mirrored validators (weborder.json `components.schemas`). Keep the
// regexes byte-identical so a failed client check matches the server-side
// 400 reason verbatim. If the spec changes, update here too.
//
// Source patterns:
//   password      InsuredRequest.password / InsuredLoginRequest.password
//   npi           InsuredRequest.npiNumber  → `^$|^\d{10}$`
//   licenseNumber InsuredRequest.licenseNumber → `^$|^[A-Za-z0-9]+$`, maxLen 40
//   mdy date      InsuredOrderRequest.effectiveDate → MM/DD/YYYY
export const PASSWORD_RULE =
  "Password must be at least 6 characters and include an uppercase letter, lowercase letter, digit, and special character (@$!%*?&).";

export const isValidPassword = (p) =>
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=\S+$).{6,128}$/
    .test(String(p || ""));

// Empty allowed (spec uses `^$|...`) so the field stays optional.
export const isValidNpi = (n) => {
  const s = String(n || "");
  return s === "" || /^\d{10}$/.test(s);
};

export const isValidLicenseNumber = (l) => {
  const s = String(l || "");
  return s === "" || /^[A-Za-z0-9]{1,40}$/.test(s);
};

// MM/DD/YYYY pattern. Calendar correctness (Feb 30, etc.) is the backend's
// job — this guards the shape so the request doesn't 400 on regex alone.
export const isValidMdyDate = (d) =>
  /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(String(d || ""));
